import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const slideIn = [
  query(':enter, :leave', style({ overflow: 'hidden', width: '100%' }), { optional: true }),
  group([
    query(
      ':enter',
      [
        style({ opacity: 1, position: 'fixed', transform: 'translateX(-100%)' }),
        animate('100ms ease-out', style({ opacity: 0, transform: 'translateX(0%)' }))
      ],
      { optional: true }
    ),
    query(
      ':leave',
      [
        style({ opacity: 1, position: 'fixed', transform: 'translateX(0%)' }),
        animate('100ms ease-out', style({ opacity: 0, transform: 'translateX(100%)' }))
      ],
      { optional: true }
    )
  ])
];
export const slideOut = [
  query(':enter, :leave', style({ overflow: 'hidden', width: '100%' }), { optional: true }),
  group([
    query(
      ':enter',
      [
        style({ opacity: 1, position: 'fixed', transform: 'translateX(100%)' }),
        animate('100ms ease-out', style({ opacity: 1, transform: 'translateX(0%)' }))
      ],
      { optional: true }
    ),
    query(
      ':leave',
      [
        style({ opacity: 1, transform: 'translateX(0%)' }),
        animate('100ms ease-out', style({ opacity: 0, position: 'fixed', transform: 'translateX(-100%)' }))
      ],
      { optional: true }
    )
  ])
];

export const slideInOut = trigger('slideInOut', [
  transition('* => slideIn', slideIn),
  transition('* => slideOut', slideOut)
]);
